import { useState, useEffect } from 'react';
import quranApi from '../../api/quranApi';
import { FaCheckCircle, FaChevronUp, FaChevronDown } from 'react-icons/fa';

const SurahList = ({ onSelectSurah, selectedSurah, completedSurahs = [] }) => {
    const [surahs, setSurahs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);

    // Initialize expanded state based on screen width
    // Desktop (> 768px): Always expanded initially
    // Mobile (<= 768px): Collapsed initially (or expanded, but collapsible)
    const [isExpanded, setIsExpanded] = useState(window.innerWidth > 768);

    useEffect(() => {
        const fetchSurahs = async () => {
            try {
                const data = await quranApi.getAllSurahs();
                setSurahs(data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching surahs', error);
                setLoading(false);
            }
        };

        fetchSurahs();
    }, []);

    // Ensure list is expanded when switching to desktop view
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setIsExpanded(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const filteredSurahs = surahs.filter(
        (surah) =>
            surah.englishName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            surah.name.includes(searchTerm) ||
            surah.englishNameTranslation.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const toggleList = () => {
        // Only allow toggling on mobile/tablet
        if (window.innerWidth <= 768) {
            setIsExpanded(!isExpanded);
        }
    };

    const handleSurahClick = (surahNumber) => {
        onSelectSurah(surahNumber);
        // Auto-collapse on mobile after selection
        if (window.innerWidth <= 768) {
            setIsExpanded(false);
        }
    };

    if (loading) return <div>Chargement des sourates...</div>;

    return (
        <div className="surah-list-container">
            <div className="surah-list-header" onClick={toggleList}>
                <h3>Sourates</h3>
                <span className="toggle-icon">
                    {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                </span>
            </div>

            {isExpanded && (
                <>
                    <div className="search-box">
                        <input
                            type="text"
                            placeholder="Rechercher une sourate..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="form-control"
                        />
                    </div>
                    <ul className="surah-list">
                        {filteredSurahs.map((surah) => (
                            <li
                                key={surah.number}
                                className={`surah-item ${selectedSurah === surah.number ? 'active' : ''}`}
                                onClick={() => handleSurahClick(surah.number)}
                            >
                                <div className="surah-info">
                                    <span className="surah-number">{surah.number}</span>
                                    <div className="surah-names">
                                        <span className="surah-name-en">{surah.englishName}</span>
                                        <span className="surah-name-ar">{surah.name}</span>
                                    </div>
                                </div>
                                <div className="surah-meta">
                                    <span className="ayah-count">{surah.numberOfAyahs} Versets</span>
                                    {completedSurahs.includes(surah.number) && (
                                        <FaCheckCircle className="completed-icon" />
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
};

export default SurahList;
